import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { CouponType } from "../../constants";
import { requestChangeCouponStatus } from "./changeCouponStatus.request";

const useCouponStatusChange = (
  couponType: CouponType,
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchCoupons = useRefetchQuery(["coupons", couponType]);

  return useMutation({
    mutationFn: requestChangeCouponStatus,
    ...options,
    onSuccess: (...args) => {
      refetchCoupons();
      options?.onSuccess?.(...args);
    }
  });
};

export default useCouponStatusChange;
